<!--  -->
<template>
  <div>
    <div class="header">
        <div class="box">
            <div class="L"><a onClick="javascript:history.back(-1)" class="goback"><img src="/static/images_m/goback.png" /></a></div>
            <div class="C"><p>课程·{{course.title}}</p></div>
        </div>
        <section class="breadcrumb-area breadcrumb-area2" :style="`background-color: #77208db8;height: 195px;background-image:url(${global.remoteIp}/uploads/${course.picsrc})`">
          <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-content">
                        <p class="breadcrumb__meta"><span class="seller-badge">{{course.spltip}}</span></p>
                        <h2 class="breadcrumb__title">{{course.title}}</h2>
                        <ul class="breadcrumb__list">
                            <li>讲师： <router-link :to="`/views/${plateid}`">{{course.author}}</router-link></li>
                            <li>
                                <i :class="`la la-star${course.stars==0.5?'-half':course.stars>=1?'':'-o'}`"></i>
                                <i :class="`la la-star${course.stars==1.5?'-half':course.stars>=2?'':'-o'}`"></i>
                                <i :class="`la la-star${course.stars==2.5?'-half':course.stars>=3?'':'-o'}`"></i>
                                <i :class="`la la-star${course.stars==3.5?'-half':course.stars>=4?'':'-o'}`"></i>
                                <i :class="`la la-star${course.stars==4.5?'-half':course.stars>=5?'':'-o'}`"></i>
                                <!-- {{course.stars}} -->
                            </li>
                            <li>{{course.students?course.students:'0'}} 人报名</li>
                            <li><i class="la la-globe"></i> 北京</li>
                            <li style="color:red; font-weight: bold">到期时间：{{course.endtime}}</li>
                        </ul>
                    </div><!-- end breadcrumb-content -->
                </div><!-- end col-lg-12 -->
            </div><!-- end row -->
          </div><!-- end container -->
        </section>

    </div>  
    <div class="h54"></div>
    <div class="clear"></div>
    <el-tabs type="border-card" :stretch="true">
      <el-tab-pane>
        <span slot="label"><i class="el-icon-tickets"></i> 课程简介</span>
         <p class="description__text" v-html="course.description"></p>
      </el-tab-pane>
      <el-tab-pane> <span slot="label"><i class="el-icon-notebook-2"></i> 课程目录</span>
        <!-- <el-collapse v-model="activeName" accordion>
          <el-collapse-item v-for="(Class,index) in course.classes" :key="index" :title="Class.title" :name="index">
            <div v-for="o in 4" :key="o" class="text item">
              {{'列表内容 ' + o }}
            </div>
          </el-collapse-item>
        </el-collapse> -->
       <div class="curriculum-content" >
          <div class="accordion course-accordion" id="accordionExample">
              <div class="card" v-for="(Class,index) in course.classes" :key="index">
                  <div class="card-header" id="headingOne">
                      <h2 class="mb-0">
                          <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                              <i class="la la-angle-up"></i>
                              <i class="la la-angle-down"></i>
                              {{Class.title}}
                              <span class="btn-text">{{Class.counts}} 节</span>
                          </button>
                      </h2>
                  </div><!-- end card-header -->
                  <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                      <div class="card-body">
                          <ul class="card-list">
                              <li class="card-list-item" v-for="(video,indexex) in Class.videos" :key="indexex">
                                  <span class="course-duration">{{parseInt((parseFloat(video.info.time)*60)) }} min</span>
                                  <button type="button" class="preview-link" @click="showVideo(video,indexex)">
                                      <i class="la la-play-circle-o course-play__icon"></i> {{video.info.title}}
                                  </button>
                              </li>
                          </ul>
                      </div><!-- end card-body -->
                  </div><!-- end collapse -->
              </div><!-- end card -->
          </div><!-- end accordion -->
      </div><!-- end curriculum-content -->
      </el-tab-pane>
      <el-tab-pane><span slot="label"><i class="el-icon-chat-dot-square"></i> 学员评论</span>
      <div class="comments-wrapper">
       <ul class="comments-list">
          <li>
              <div class="comment" v-for="(comment, index) in comments" :key="index">
                  <div class="comment-body">
                      <div class="meta-data">
                           <el-avatar icon="el-icon-user-solid"></el-avatar>
                           <div class="name-box">
                            <div class="name">{{comment.username}}</div>
                            <div class="time">{{dateFormat(new Date(comment.createdAt),"yyyy-MM-dd hh:mm:ss")}}</div>
                           </div>
                      </div>
                      <p class="comment-content">
                        <span style="font-weight:600;color: #000000;"></span> {{comment.comment}}
                      </p>
                  </div>
              </div><!-- end comment -->
          </li>
        </ul>
        <el-input placeholder="请输入评论" v-model="commentMsg" style="width: 100%;
    position: fixed;
    bottom: 54px;
    left: 0px;">
          <el-button slot="append" icon="el-icon-s-promotion" @click="submitComment()"></el-button>
        </el-input>
      </div> 
      </el-tab-pane>
    </el-tabs>
    <el-dialog
        :title="`正在学习: ${video.title}`"
        :visible.sync="dialogVisible"
        :width="global.isPhone()? '95%':'50%'"
        :close-on-click-modal="false"
        :before-close="handleClose"
        append-to-body>
        <el-divider></el-divider> 
        <div class="player-container" ref="VideoPlay" style="height:auto" data-ratio="16:9">
            <!-- <vue-core-video-player :autoplay="false"  :cover="`${global.remoteIp}/uploads/${video.picsrc}`" :src="`${global.remoteIp}/videoplay/${video.videosrc}?courseid=${course._id}`" :controls="auto"></vue-core-video-player> -->
            <!-- <LivePlayer :cover="`${global.remoteIp}/uploads/${video.picsrc}`"  :videoUrl="videoSrc" fluent autoplay hide-stretch-button></LivePlayer> -->
          <el-image v-if="video.isAudio"  :style="`width: 100%;height:${elImageHigh}`" :src="`${global.remoteIp}/uploads/${video.picsrc}`" ref="elImage"></el-image>
          <audio v-if="video.isAudio"
            style="width: 100%;"
            :src="videoSrc" controls="controls">
          Your browser does not support the audio element.
          </audio>
          <video-play v-else-if="videoSrc" :options="{url:videoSrc,videoId:video._id}" :style="`height:${videoHigh}`"/>
        </div>
    </el-dialog>
    <el-dialog
      :visible.sync="payInfoVisible"
      :width="global.isPhone()? '90%':'30%'"
      center
      >
      <el-descriptions title="订单信息" :column="1" border>
        <el-descriptions-item label="课程名称">{{payInfoCourse.title}}</el-descriptions-item>
        <el-descriptions-item label="课程讲师">{{payInfoCourse.author}}</el-descriptions-item>
        <el-descriptions-item label="课程科目">{{payInfoCourse.type}}</el-descriptions-item>
        <el-descriptions-item label="课程价格">{{payInfoCourse.price}}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payInfoVisible = false; cancelPay()" >取 消</el-button>
        <el-button type="primary" @click="payInfoVisible = false;creatOrder()" >线上支付</el-button>
        <el-button type="primary" @click="payInfoVisible = false;showTearch()" >线下支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import global from "@/components/PublicComs/Common.vue";
// import LivePlayer from '@liveqing/liveplayer'
import VideoPlay from '../components/PublicComs/VideoPlay.vue';
import { Message } from "element-ui";
import jwt_decode from "jwt-decode";
export default {
  data() {
    return {
      course: {},
      subjects: [],
      newCourse: [],
      global,
      options: {
        i18n: {
          speed: "速度",
          normal: "正常",
        },
      },
      video: {},
      dialogVisible: false,
      payInfoCourse:{},
      payInfoVisible:false,
      videoSrc: "",
      videoHigh:0,
      commentMsg:"",
      comments: [],
      intTotal:0,
      commentStars:"",
      plateid:"",
      isCourseStar:false,
      StarRate:{
        '1': "0",
        '2': "0",
        '3': "0",
        '4': "0",
        '5': "0",
      },
      elImageHigh:"",
      webConfig:{},
      userInfo:{}
    };
  },
  props: {
    plates: Array,
  },
  components: { VideoPlay },

  computed: {},

  mounted() {
   
    let courseId = this.$route.params.id;
    this.$axios.get(`/api/courses/visitor/${courseId}`).then((res) => {
      if (res.data) {
        this.course = res.data.data;
        this.isCourseStar = this.course.isCourseStar;
        if(this.course.isBuy==3)
        {
          this.$alert(`开课时间为${this.course.studystarttime}`, '提示', {
            confirmButtonText: '确定',
            callback: action => {
              
            }
          });
        }else if(this.course.isBuy==4){
          this.$alert(`课程已结束`, '提示', {
            confirmButtonText: '确定',
            callback: action => {
              
            }
          });
        }
        if (!this.course.addtime) {
          let addtime = this.course.createdAt;
          let date = new Date(addtime);
          this.course.addtime = `${date.getFullYear()}-${(
            "00" +
            (date.getMonth() + 1)
          ).slice(-2)}-${("00" + date.getDate()).slice(-2)} ${(
            "00" + date.getHours()
          ).slice(-2)}:${("00" + date.getMinutes()).slice(-2)}:${(
            "00" + date.getSeconds()
          ).slice(-2)}`;
        }
        // this.course.stars = this.course.courseStarAvg[0].avgStar;
        let totalStars=0;
        for(let i =0 ; i < this.course.courseStarGroup.length;i++) {
          totalStars += this.course.courseStarGroup[i].count;
        }
        for(let i =0 ; i < this.course.courseStarGroup.length;i++) {
          let id= this.course.courseStarGroup[i]._id;
          this.StarRate[id.toString()] =((this.course.courseStarGroup[i].count/totalStars)*100).toFixed(2);
        }
        
      }
    });
     let strextra="";
      if(this.$root.onlymycourse)
      {
        strextra="&type[in]="+ this.$root.hasCourse;
      }
    this.$axios
      .get("/api/courses/visitor?page=1&limit=6&sort=-createdAt"+strextra)
      .then((res) => {
        if (res.data) {
          this.newCourse = res.data.data;
        }
      });
    this.$axios.get("/api/courseTypes?sort=-createdAt").then((res) => {
      if (res.data) {
        this.subjects = res.data.data;
      }
    });
    for (var i = 0; i < this.plates.length; i++) {
      if (this.plates[i].name == "名师简介") {
        this.plateid = this.plates[i]._id;
      }
    }
     this.$axios.get("/api/auth/me").then(res => {
          const { token } = res.data;
          localStorage.setItem("eleTokenCustCysd001", token);
          // 解析token
          const decode = jwt_decode(token);
          // 存储数据
          this.$store.dispatch("setIsAutnenticated", !this.isEmpty(decode));
          this.$store.dispatch("setUser", decode);
           let arrhasCourse = [];
          for (var i = 0; i <res.data.data.needexaminee.length; i++)
          {
            arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
          }
          this.$root.hasCourse =arrhasCourse;
          this.userInfo = res.data.data;
        })
    this.timer=setInterval(()=>{
        this.$axios.get("/api/auth/me").then(res => {
          const { token } = res.data;
          localStorage.setItem("eleTokenCustCysd001", token);
          // 解析token
          const decode = jwt_decode(token);
          // 存储数据
          this.$store.dispatch("setIsAutnenticated", !this.isEmpty(decode));
          this.$store.dispatch("setUser", decode);
          let arrhasCourse = [];
          for (var i = 0; i <res.data.data.needexaminee.length; i++)
          {
            arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
          }
          this.$root.hasCourse =arrhasCourse;
        })
      },1000*60*10);
    this.$axios
      .get(`/api/courseComments/user?courseid=${courseId}&limit=5&sort=-createdAt`)
      .then((res) => {
        if (res.data) {
          this.comments = res.data.data;
          this.intTotal = res.data.total;
        }
      });

    this.$axios.get("/api/webConfigs").then(res => {
        if(res.data&&res.data.data.length>0)
        {
            this.webConfig = res.data.data[0];
        }
    }); 
  },

  methods: {
    isEmpty(value) {
      return (
        value === undefined ||
        value === null ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim().length === 0)
      );
    },
    toPage(intcount) {
       this.$axios
        .get(
          `/api/courseComments/user?page=${
            intcount
          }&limit=5&sort=-createdAt&courseid=${this.course._id}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.comments = res.data.data;
          }
        });
    },
    showVideo(video) {
      if(this.course.isBuy!=1) {
        //未购买课程
        var strTip = "该课程为未报名观看，是否立即报名学习?";
        if(this.course.isBuy==2)
        {
          strTip = "该课程已到期，是否重新报名学习?";
        }
        if(!video.isShiKan)
        {
          this.$alert(`此视频暂不支持试看`, '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        }else{
        this.$confirm(strTip, '提示', {
          confirmButtonText: '立即报名',
          cancelButtonText: '试看',
          type: 'warning'
        }).then(() => {
          this.showTearch();
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消'
          // });        
           this.video = video.info;
            //this.videoSrc=`${this.global.remoteIp}/videoplay/${this.video.videosrc}?courseid=${this.course._id}`
            this.videoSrc=this.video.videosrc;
            this.dialogVisible = true;
            this.$nextTick(function(){
                this.videoHigh = (this.$refs.VideoPlay.clientWidth)*0.5625 + "px";
                this.elImageHigh =(this.$refs.VideoPlay.clientWidth)*0.5625 + "px";
              })  
        });
      }
      }else{
        this.video = video.info;
            //this.videoSrc=`${this.global.remoteIp}/videoplay/${this.video.videosrc}?courseid=${this.course._id}`
            this.videoSrc=this.video.videosrc;
            this.dialogVisible = true;
            this.$nextTick(function(){
                this.videoHigh = (this.$refs.VideoPlay.clientWidth)*0.5625 + "px";
                this.elImageHigh =(this.$refs.VideoPlay.clientWidth)*0.5625 + "px";
              })  
      }
    },
    showTearch(){
      this.$alert(`您可以联系${this.webConfig.contact}，联系电话：${this.webConfig.mobile}`, '报名方式', {
          confirmButtonText: '确定',
          callback: action => {
           this.$axios.post(`/api/userSignUps`,{
              userid:this.userInfo._id,
              username:this.userInfo.name,
              courseid:this.course._id,
              coursetype:this.course.type,
              coursename:this.course.title,
              teacherid:this.course.createuserid,
              teachername:this.course.createusername
            })
          }
        });
    },
    handleClose() {
      this.videoSrc="";
      this.dialogVisible = false;
    },
    creatOrder(){
      const loading = this.$loading({
          lock: true,
          text: '正在创建订单，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.global.isPhone()?
      this.$axios.post(`/api/zfb/createOrder_m`,{
        payName:"购买在线课程",
        goodsName:"在线课程-"+this.course.title,
        count:1,
        goodsId:this.course._id,
        returnHtml:"<script> + window.open('" + this.global.remoteIp + "/courview/info/"+this.course._id+"','_self') <\/script>"
      }).then((res) => {
         // loading.close();
           const div=document.createElement('divform');
          div.innerHTML=res.data;
          document.body.appendChild(div);
          document.forms[0].submit();
      }).catch((e) => {
        loading.close();
      })
      :
      this.$axios.post(`/api/zfb/createOrder_pc`,{
        payName:"购买在线课程",
        goodsName:"在线课程-"+this.course.title,
        count:1,
        goodsId:this.course._id,
        returnHtml:"<script> + window.open('" + this.global.remoteIp + "/courview/info/"+this.course._id+"','_self') <\/script>"
      }).then((res) => {
        //loading.close();
           const div=document.createElement('divform');
          div.innerHTML=res.data;
          document.body.appendChild(div);
          document.forms[0].submit();
      }).catch((e) => {
        loading.close();
      });
    },
    cancelPay(){
      this.payInfoCourse = {};
    },
    enterPay(){
      if(this.course.isBuy!=1)
      {
        this.$axios.get(`/api/zfb/payinfo/?_id=${this.course._id}`).then((res) => {
          this.payInfoCourse = res.data.data;
          this.payInfoVisible = true;
        });
      }
    },
    dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
    submitComment(){
      if(!this.commentMsg)return;
      this.$axios.post(`/api/courseComments/user`,{
        courseid:this.course._id,
        comment: this.commentMsg
      }).then((res) => {
         if(res&&res.data){
           this.$message({
             message: '评论成功',
             type: 'success',
             offset:100
           });
           this.commentMsg="";
           this.toPage(0)
         }
      })
    },
    commitStars(){
       this.$axios.post(`/api/courseStars/user`,{
        courseid:this.course._id,
        stars: this.commentStars
      }).then((res) => {
         if(res&&res.data){
           Message.success("评分成功");
           this.isCourseStar = true;
         }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-divider--horizontal {
  margin-bottom: 20px;
  margin-top: 0px;
}
::v-deep .el-dialog__body {
  padding: 5px 20px 30px 20px;
}
::v-deep .el-dialog__title {
  color: #233d63;
  font-size: 29px;
  line-height: 33px;
  font-weight: 500;
}
@media (max-width: 405px) {
  ::v-deep .el-dialog__title {
    color: #233d63;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
  }
  ::v-deep .el-dialog__body {
  padding: 5px 5px 5px 5px;
}
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #6510AD;
}
::v-deep .el-pager li.active {
  color: #6510AD;
}
.la{
  color: #F68A03;
}
.la-globe{
  color: #F68A03;
}
  @import "@/assets/css/style_Phone.scss";
  .container{
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }

  ::v-deep .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
    color: #6510AD;
  }
  ::v-deep .el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover{
    color: #6510AD;
  }
  
 .curriculum-content .course-accordion .card {
  margin-bottom: 4px;
  border-color: rgba(127, 136, 151, 0.3);
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}

 .curriculum-content .course-accordion .card:first-of-type {
  border-bottom: 1px solid rgba(127, 136, 151, 0.3);
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}

 .curriculum-content .course-accordion .card:not(:first-of-type):not(:last-of-type) {
  border-bottom: 1px solid rgba(127, 136, 151, 0.3);
}

 .curriculum-content .course-accordion .card .card-header {
  padding: 0;
  text-align: left;
  background-color: #F7FAFD;
  border-bottom-color: rgba(127, 136, 151, 0.3);
}

 .curriculum-content .course-accordion .card .card-header .btn-link {
  display: block;
  width: 100%;
  text-align: left;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  padding: 10px 20px 10px 35px;
  border: none;
  color: #233d63;
  text-decoration: none;
  font-size: 18px;
  position: relative;
  font-weight: 500;
}

 .curriculum-content .course-accordion .card .card-header .btn-link i.la {
  display: none;
  position: absolute;
  left: 10px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  color: #7f8897;
}

 .curriculum-content .course-accordion .card .card-header .btn-link .btn-text {
  float: right;
  color: #7f8897;
  font-size: 16px;
}

 .curriculum-content .course-accordion .card .card-header .btn-link[aria-expanded=true] i.la.la-angle-up {
  display: block;
}

 .curriculum-content .course-accordion .card .card-header .btn-link[aria-expanded=false] i.la.la-angle-down {
  display: block;
}

 .curriculum-content .course-accordion .card .card-body {
  padding: 0;
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item {
  position: relative;
  border-bottom: 1px solid rgba(127, 136, 151, 0.2);
  padding: 10px 20px 10px 10px;
}

@media (max-width: 375px) {
   .curriculum-content .course-accordion .card .card-body .card-list .card-list-item {
    padding-left: 10px;
  }
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item:last-child {
  border-bottom: 0;
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .course-play__icon {
  margin-right: 5px;
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .course-duration {
  position: absolute;
  right: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  color:#6510AD;
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .preview-link {
  background-color: transparent;
  outline: none;
  border: none;
  color: #6510AD;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .preview-link:hover {
  color: #233d63;
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .modal .modal-title {
  line-height: 26px;
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .modal .modal-dialog {
  max-width: 650px;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
   .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .modal .modal-dialog {
    max-width: 500px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
   .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .modal .modal-dialog {
    max-width: 500px;
  }
}

@media (max-width: 575px) {
   .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .modal .modal-dialog {
    max-width: 100%;
  }
}
@media only screen and (min-width: 480px) and (max-width: 767px) {
  .comments-wrapper .comments-list li .comment {
    text-align: left;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .comments-wrapper .comments-list li .comment {
    text-align: left;
  }
}
.el-tabs__content img {
  max-width: 100%;
}
.name-box{
  width: 70%;
    height: -4px;
    margin-left: 10px;
}
.name-box .name{
     font-size: 20px;
    line-height: 26px;
    color: #2B333B;
    font-weight: 700;
    margin-bottom: 0.16rem;
}
.name-box .time{
    line-height: 11px;
    font-size: 10px;
    color: #B7BBBF;
}
.meta-data{
      display: flex;
    align-items: center;
    height: 0.85333333rem;
    margin-bottom: 0.26666667rem;
    font: 14px/2em "PingFang SC","微软雅黑","Microsoft YaHei",Helvetica,"Helvetica Neue",Tahoma,Arial,sans-serif;
}

/*=============== comments-wrapper ===============*/
.comments-wrapper .comments-title,
.comments-wrapper .contact-title {
  font-size: 24px;
  font-weight: 600;
}

.comments-wrapper .comments-list {
  margin-top: 20px;
  padding-top: 10px;
  margin-bottom: 25px;
  border-top: 1px solid rgba(127, 136, 151, 0.2);
}

.comments-wrapper .comments-list li .comment {
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
  margin-top: 25px;
  /* padding-bottom: 50px; */
}


.comments-wrapper .comments-list li .comment .avatar__img {
  width: 100px;
  height: 100px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  margin-right: 20px;
  float: left;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .comments-wrapper .comments-list li .comment .avatar__img {
    float: none;
    margin-right: 0;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .comments-wrapper .comments-list li .comment .avatar__img {
    float: none;
    margin-right: 0;
  }
}

.comments-wrapper .comments-list li .comment .comment-body {
  margin-left: 20px;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .comments-wrapper .comments-list li .comment .comment-body {
    margin-left: 0;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .comments-wrapper .comments-list li .comment .comment-body {
    margin-left: 0;
  }
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data {
  position: relative;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .comments-wrapper .comments-list li .comment .comment-body .meta-data {
    margin-top: 15px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .comments-wrapper .comments-list li .comment .comment-body .meta-data {
    margin-top: 15px;
  }
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data .comment__author {
  font-size: 18px;
  text-transform: capitalize;
  color: #233d63;
  margin-bottom: 5px;
  display: inline-block;
  font-weight: 600;
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data .comment__date {
  font-size: 15px;
  color: #7f8897;
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars {
  position: absolute;
  right: 10px;
  top: 10px;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars {
    position: inherit;
    right: auto;
    top: auto;
    margin-top: 4px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars {
    position: inherit;
    right: auto;
    top: auto;
    margin-top: 4px;
  }
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars li {
  display: inline-block;
  color: #F68A03;
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars li:nth-child(4),
.comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars li:nth-child(5) {
  color: #7f8897;
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars2 li:nth-child(4) {
  color: #F68A03;
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars3 li:nth-child(4),
.comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars3 li:nth-child(5) {
  color: #F68A03;
}

.comments-wrapper .comments-list li .comment .comment-body .comment-content {
font-size: 14px;
    color: #2B333B;
    word-wrap: break-word;
    text-align: justify;
}

@media (max-width: 600px) {
  .comments-wrapper .comments-list li .comment .comment-body .comment-content {
    margin-bottom: 20px;
  }
}

.comments-wrapper .comments-list li .comment .comment-body .comment-reply .comment__btn {
  color: #7f8897;
  position: relative;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  font-size: 16px;
  display: inline-block;
  padding: 7px 18px;
  border: 1px solid #eee;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 30px;
  font-weight: 500;
}

.comments-wrapper .comments-list li .comment .comment-body .comment-reply .comment__btn:hover {
  background-color: #51be78;
  color: #fff;
  border-color: #51be78;
}

.comments-wrapper .comments-list li .comment .comment-body .comment-reply .helpful__action {
  float: right;
  margin-top: 10px;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .comments-wrapper .comments-list li .comment .comment-body .comment-reply .helpful__action {
    margin-top: 30px;
    float: none;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .comments-wrapper .comments-list li .comment .comment-body .comment-reply .helpful__action {
    margin-top: 30px;
    float: none;
  }
}

.comments-wrapper .comments-list li .comment .comment-body .comment-reply .helpful__action a {
  border: 1px solid rgba(128, 137, 150, 0.4);
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  padding: 4px 12px;
  color: #7f8897;
  margin-left: 3px;
  margin-right: 3px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.comments-wrapper .comments-list li .comment .comment-body .comment-reply .helpful__action a:hover {
  background-color: rgba(128, 137, 150, 0.1);
  color: #233d63;
}

.comments-wrapper .comments-list li .comments-reply {
  margin-left: 130px;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .comments-wrapper .comments-list li .comments-reply {
    margin-left: 0;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .comments-wrapper .comments-list li .comments-reply {
    margin-left: 0;
  }
}

.comments-wrapper .see-more-review-btn {
  margin-bottom: 50px;
}

.comments-wrapper .see-more-review-btn .button-shared .theme-btn {
  line-height: 45px;
  padding-right: 20px;
  padding-left: 20px;
  font-size: 15px;
  outline: none;
}
::v-deep .el-input-group__append, .el-input-group__prepend
{
  background-color: #c1acd3;
    color: #874eb7;
    vertical-align: middle;
    display: table-cell;
    position: relative;
    border: 1px solid #c1acd3;
    border-radius: 4px;
    padding: 0 20px;
    width: 1px;
    white-space: nowrap;
    font-size: 20px;
}


/*====================================================
    breadcrumb-area
 ====================================================*/
.breadcrumb-area {
  background-color: #F7FAFD;
  height: 450px;
  display: -webkit-flex;
  display: -ms-flex;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  text-align: center;
  z-index: 2;
  color: #fff;
  background-image: url("/static/images/breadcrumb-bg.jpg");
  background-size: cover;
  background-position: center;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .breadcrumb-area {
    height: 300px;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .breadcrumb-area {
    height: 300px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .breadcrumb-area {
    height: 300px;
  }
}

@media (max-width: 375px) {
  .breadcrumb-area {
    height: 220px;
  }
}

.breadcrumb-area .breadcrumb-content {
  position: relative;
  z-index: 3;
}

.breadcrumb-area .breadcrumb-content .breadcrumb__title {
  font-size: 70px;
  text-transform: capitalize;
  font-weight: 700;
  color: #fff;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .breadcrumb-area .breadcrumb-content .breadcrumb__title {
    font-size: 50px;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .breadcrumb-area .breadcrumb-content .breadcrumb__title {
    font-size: 50px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .breadcrumb-area .breadcrumb-content .breadcrumb__title {
    font-size: 40px;
  }
}

.breadcrumb-area .breadcrumb-content .breadcrumb__list {
  margin-top: 8px;
}

.breadcrumb-area .breadcrumb-content .breadcrumb__list li {
  display: inline-block;
  text-transform: capitalize;
  color: #F7FAFD;
  font-size: 16px;
  font-weight: 500;
  position: relative;
  padding-right: 22px;
}

.breadcrumb-area .breadcrumb-content .breadcrumb__list li:last-child {
  padding-right: 0;
}

.breadcrumb-area .breadcrumb-content .breadcrumb__list li a {
  color: #F7FAFD;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.breadcrumb-area .breadcrumb-content .breadcrumb__list li a:hover {
  color: #51be78;
}

.breadcrumb-area .breadcrumb-content .breadcrumb__list li.active__list-item:after {
  position: absolute;
  content: '.';
  top: -6px;
  right: 0;
  padding: 0 6px;
  font-size: 20px;
}

.breadcrumb-area .breadcrumb-content .text-outline {
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(255, 255, 255, 0.1);
  -ms-text-stroke-color: rgba(255, 255, 255, 0.1);
  -o-text-stroke-color: rgba(255, 255, 255, 0.1);
  font-size: 140px;
  color: transparent;
  position: absolute;
  letter-spacing: -0.02em;
  bottom: -115px;
  left: 0;
  right: 0;
  z-index: -1;
  text-transform: capitalize;
  font-weight: 600;
}

@media (max-width: 1199px) {
  .breadcrumb-area .breadcrumb-content .text-outline {
    display: none;
  }
}

.breadcrumb-area:before {
  position: absolute;
  content: '';
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #233d63;
  opacity: 0.9;
  z-index: -1;
}


/*====================================================
    breadcrumb-area 2
 ====================================================*/
.breadcrumb-area2 {
  text-align: left;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .breadcrumb-area2 {
    height: 450px;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .breadcrumb-area2 {
    height: 450px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .breadcrumb-area2 {
    height: 450px;
  }
}

.breadcrumb-area2 .breadcrumb-content {
  padding-right: 400px;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .breadcrumb-area2 .breadcrumb-content {
    padding-right: 0;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .breadcrumb-area2 .breadcrumb-content {
    padding-right: 0;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .breadcrumb-area2 .breadcrumb-content {
    padding-right: 0;
  }
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__meta {
  margin-bottom: 5px;
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__meta .seller-badge {
  background-color: #51be78;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  display: inline-block;
  padding: 4px 10px 4px 12px;
  -webkit-border-radius: 4px 4px 0 4px;
  -moz-border-radius: 4px 4px 0 4px;
  border-radius: 4px 4px 0 4px;
  font-size: 12px;
  position: relative;
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__meta .seller-badge:after {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 6px;
  z-index: -1;
  background-color: #51be78;
  -webkit-transform-origin: bottom left;
  transform-origin: bottom left;
  -webkit-transform: skew(12deg, 0deg);
  -moz-transform: skew(12deg, 0deg);
  -ms-transform: skew(12deg, 0deg);
  -o-transform: skew(12deg, 0deg);
  transform: skew(12deg, 0deg);
  -webkit-border-radius: 4px 4px 0 4px;
  -moz-border-radius: 4px 4px 0 4px;
  border-radius: 4px 4px 0 4px;
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__title {
  font-size: 50px;
  text-transform: inherit;
  line-height: 58px;
}

@media (max-width: 575px) {
  .breadcrumb-area2 .breadcrumb-content .breadcrumb__title {
    font-size: 40px;
    line-height: 50px;
  }
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__list {
  margin-top: 20px;
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__list li {
  text-transform: inherit;
  padding-right: 10px;
  padding-bottom: 5px;
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__list li:last-child {
  padding-bottom: 0;
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__list li i.la {
  color: #F68A03;
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__list li i.la-globe {
  color: #fff;
}
  .breadcrumb-area2{
    top:45px; 
  }
  .breadcrumb-area:before{
        background-color: #6e27a9e6;
  }
</style>
